import styled from '../../utils/styled';
import { mediaBreakpointUpMD } from '../../../constants/style-constants';

export const SecondaryNavigationContainer = styled.div(({ alternate }) => ({
  display: 'none',
  backgroundColor: '#101010',
  borderBottom: alternate ? 'none' : '1px solid black',
  color: 'white',
  height: '40px',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  opacity: '0',

  [mediaBreakpointUpMD]: {
    display: 'flex',
  },
}));
